import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { GET_ENTRY_STRATEGIES } from './actionTypes';
import { getEntryStrategiesSuccess, getEntryStrategiesError } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* getEntryStrategies({ payload: token }) {
  try {
    const response = yield call(entryStrategiesAPI.getEntryStrategies, token);
    yield put(getEntryStrategiesSuccess(response));
  } catch (error) {
    yield put(getEntryStrategiesError(error));
  }
}

export function* watchGetEntryStrategies() {
  yield takeEvery(GET_ENTRY_STRATEGIES, getEntryStrategies);
}

function* getEntryStrategiesSaga() {
  yield all([fork(watchGetEntryStrategies)]);
}

export default getEntryStrategiesSaga;
